module.exports = __webpack_public_path__ + "img/skimmer_parked.773947fd.svg";